import { Step } from 'react-joyride';
import { AppTourData } from '../../data-types/app-tour/appTourInterfaces';

export type AppTourType = SetTourData;

export const SET_TOUR_DATA = 'SET_TOUR_DATA';

export interface AppTourState {
  steps: Step[];
  run: boolean;
  startingIndex: number;
}

interface SetTourData {
  type: typeof SET_TOUR_DATA;
  meta: AppTourData;
}
